import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-21",
  name: "Stillpoint",
  slug: "stillpoint",
  title: "Stillpoint — a Fable World: health launch page",
  description:
    "An original wellness landing page designed by Fable: a single-column longread where the type itself breathes, sage on chalk."
};

export default meta;
